import { useCallback } from 'react';

import { useNavigate } from 'react-router-dom';
import { ButtonMantine, Group, OneToTwoLayoutTemplate, Stack, Title } from 'ui';
import { IconAdd } from 'ui/Icons';

import { useHandleAddCardClick } from '../../../hooks/useHandleAddCardClick';
import { WalletBalanceCard } from '../../Account/Rewards/WalletBalanceCard';
import { CredentialCardList } from '../../Account/components/CredentialCards/CredentialCardList';
import { ConsumerWallet } from './ConsumerWallet';

const CardsOnFile = () => {
  const navigate = useNavigate();
  const { handleAddCardClick } = useHandleAddCardClick();

  const handleClickAddCard = useCallback(() => {
    handleAddCardClick(() => navigate('card'));
  }, [handleAddCardClick, navigate]);

  return (
    <Stack>
      <Group justify="space-between">
        <Title order={2}>Cards On File</Title>
        <ButtonMantine
          size="sm"
          variant="subtle"
          leftSection={<IconAdd />}
          // TODO-NOW: address issues with sharing namespace of add-card with previous implementation
          onClick={() => handleClickAddCard()}
        >
          Add Card
        </ButtonMantine>
      </Group>
      <CredentialCardList />
    </Stack>
  );
};

const WalletPage = () => {
  return (
    <OneToTwoLayoutTemplate
      leftSection={<WalletBalanceCard />}
      rightSection={
        <Stack>
          <ConsumerWallet />
          <CardsOnFile />
        </Stack>
      }
    />
  );
};

export { WalletPage };
